import { render, staticRenderFns } from "./station-detail-apply.vue?vue&type=template&id=159ff2f2&scoped=true&"
import script from "./station-detail-apply.vue?vue&type=script&lang=js&"
export * from "./station-detail-apply.vue?vue&type=script&lang=js&"
import style0 from "./station-detail-apply.vue?vue&type=style&index=0&id=159ff2f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ff2f2",
  null
  
)

export default component.exports